/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgNonEditable = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m5.253 15.735-.704 3.513 3.52-.703 2.88-2.874-2.806-2.821zM13.384 13.24l3.133-3.127-2.816-2.81-3.133 3.127-4.627-4.618-1.19 1.19L17.4 19.625l1.19-1.19zM18.982 7.654c1.056-1.054 0-2.108 0-2.108l-.704-.703s-1.056-1.054-2.112 0L15.11 5.897l2.816 2.811z" /></svg>;
export default SvgNonEditable;